import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import { footerGroups, siteInfo } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-950 text-background-100">
      <Container>
        <div className="grid grid-cols-1 gap-10 py-12 md:grid-cols-12 md:gap-8 md:py-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-newspaper-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/85">
              {siteInfo.slogan}。围绕五一假期整理被广泛讨论的事件、争议与行业动态，只做公开信息的归纳与时间线梳理。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3 text-xs text-background-200/80">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-mail-line" />
                {siteInfo.email}
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-refresh-line" />
                {siteInfo.updateTime}
              </span>
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title} className="md:col-span-2">
              <h3 className="font-heading text-sm font-bold text-background-50">{group.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-200/80 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3 border-t border-background-50/15 py-6 text-xs text-background-200/70 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {year} {siteInfo.fullName} · 本站内容为公开信息整理，不构成对任何个人的事实认定。
          </p>
          <p className="flex items-center gap-1.5">
            <i className="ri-information-line" />
            如需更正请联系 {siteInfo.pressEmail}
          </p>
        </div>
      </Container>
    </footer>
  );
}